module.exports = __webpack_public_path__ + "img/2013-08_bloomberg.09ecd445.png";